import { isComponentEnabled, useToggleState } from '@news-mono/web-common'
import React, { ReactNode } from 'react'
import { useLocation } from 'react-router'
import { TheNightlyNavItem } from '../../routing'
import {
    TagLinkList,
    TagLinkListItem,
    TagLink,
    TagLinkWrapper,
    Divider,
    TagLinkNavContainer,
    TrailingContent,
} from './TagLinkNavigation.styled'
import { toFeatureState } from '@west-australian-newspapers/etrigan-feature-toggles-client'

export type TagLinkNavigationProps = {
    sectionNavItem: TheNightlyNavItem
    trailingContent: ReactNode
    forceHorizontalLayout?: boolean
}

export const TagLinkNavigation = ({
    sectionNavItem,
    trailingContent,
    forceHorizontalLayout = false,
}: TagLinkNavigationProps) => {
    const location = useLocation()
    const featureState = useToggleState()

    return (
        <TagLinkNavContainer forceHorizontalLayout={forceHorizontalLayout}>
            <TagLinkWrapper forceHorizontalLayout={forceHorizontalLayout}>
                <TagLinkList forceHorizontalLayout={forceHorizontalLayout}>
                    {(sectionNavItem.subNavLinks ?? []).map(
                        ({ name, link, feature }, i) =>
                            feature &&
                            !isComponentEnabled(toFeatureState(featureState), {
                                feature,
                            }) ? (
                                <></>
                            ) : (
                                <TagLinkListItem key={i}>
                                    <TagLink
                                        to={link}
                                        forceHorizontalLayout={
                                            forceHorizontalLayout
                                        }
                                        state={
                                            link === location.pathname
                                                ? 'active'
                                                : 'default'
                                        }
                                    >
                                        {name}
                                    </TagLink>
                                </TagLinkListItem>
                            ),
                    )}
                </TagLinkList>
            </TagLinkWrapper>
            <Divider forceHorizontalLayout={forceHorizontalLayout} />
            <TrailingContent forceHorizontalLayout={forceHorizontalLayout}>
                {trailingContent}
            </TrailingContent>
        </TagLinkNavContainer>
    )
}
